// Extended Portfolio Data dengan Detail Pages

export const portfolioDetails = {
  1: {
    id: 1,
    title: "Warung Makan Bu Sari",
    category: "Food & Beverage",
    client: "Bu Sari Wahyuni",
    location: "Jakarta Selatan",
    duration: "6 Bulan",
    overview: "Transformasi digital untuk warung makan tradisional menjadi bisnis online yang sukses dengan peningkatan penjualan hingga 300%.",
    challenge: "Bu Sari memiliki warung makan dengan cita rasa authentic, namun hanya mengandalkan pelanggan walk-in. Pandemi COVID-19 membuat penjualan menurun drastis.",
    
    beforeAfter: {
      before: {
        image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
        description: "Warung tradisional dengan sistem manual dan tanpa kehadiran online"
      },
      after: {
        image: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80",
        description: "Sistem online ordering dengan branding modern dan delivery service"
      }
    },
    
    strategy: [
      {
        title: "Digital Branding",
        description: "Pembuatan logo, packaging design, dan identitas visual yang menarik untuk meningkatkan brand awareness."
      },
      {
        title: "Social Media Marketing",
        description: "Strategi konten Instagram dan Facebook dengan foto makanan yang appetizing dan customer testimonials."
      },
      {
        title: "Online Ordering System",
        description: "Implementasi sistem pemesanan online melalui WhatsApp Business dan integrasi dengan platform delivery."
      },
      {
        title: "Google My Business",
        description: "Optimisasi Google My Business untuk meningkatkan visibility di pencarian lokal."
      }
    ],
    
    results: [
      {
        metric: "Peningkatan Omzet",
        value: "300%",
        description: "Dari rata-rata Rp 3 juta/bulan menjadi Rp 12 juta/bulan"
      },
      {
        metric: "Instagram Followers",
        value: "5,200+",
        description: "Dari 0 followers menjadi 5,200+ dalam 6 bulan"
      },
      {
        metric: "Online Orders",
        value: "70%",
        description: "70% penjualan sekarang berasal dari pemesanan online"
      },
      {
        metric: "Customer Retention",
        value: "85%",
        description: "85% pelanggan menjadi repeat customer"
      }
    ],
    
    testimonial: {
      text: "Berkat Dreams Marketing, warung saya sekarang bisa menerima pesanan online. Penjualan meningkat 3x lipat dan banyak pelanggan baru yang tahu warung saya!",
      author: "Bu Sari Wahyuni",
      position: "Pemilik Warung Makan Bu Sari"
    },
    
    gallery: [
      "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    ]
  },
  
  2: {
    id: 2,
    title: "Toko Batik Nusantara",
    category: "Fashion", 
    client: "Ahmad Fauzi",
    location: "Yogyakarta",
    duration: "8 Bulan",
    overview: "Ekspansi pasar online untuk toko batik tradisional dengan peningkatan brand awareness 250% dan penetrasi pasar nasional.",
    challenge: "Toko batik dengan kualitas premium namun hanya dikenal lokal. Butuh strategi untuk menjangkau pasar yang lebih luas.",
    
    beforeAfter: {
      before: {
        image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        description: "Toko batik tradisional dengan penjualan offline saja"
      },
      after: {
        image: "https://images.unsplash.com/photo-1445205170230-053b83016050?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        description: "Brand batik modern dengan e-commerce dan presence nasional"
      }
    },
    
    strategy: [
      {
        title: "E-commerce Development",
        description: "Pembuatan website e-commerce dengan katalog produk lengkap dan sistem pembayaran terintegrasi."
      },
      {
        title: "Content Marketing",
        description: "Strategi storytelling tentang heritage batik dan proses pembuatan untuk membangun emotional connection."
      },
      {
        title: "Influencer Collaboration",
        description: "Kolaborasi dengan fashion influencer dan selebgram untuk meningkatkan brand awareness."
      },
      {
        title: "SEO & Google Ads",
        description: "Optimisasi SEO dan kampanye Google Ads untuk meningkatkan visibility di search engine."
      }
    ],
    
    results: [
      {
        metric: "Brand Awareness",
        value: "250%",
        description: "Peningkatan brand recognition di media sosial"
      },
      {
        metric: "Online Sales",
        value: "Rp 45 Juta",
        description: "Revenue online dalam 6 bulan pertama"
      },
      {
        metric: "Market Reach",
        value: "15 Kota",
        description: "Ekspansi ke 15 kota besar di Indonesia"
      },
      {
        metric: "Website Traffic",
        value: "400%",
        description: "Peningkatan traffic website organik"
      }
    ],
    
    testimonial: {
      text: "Tim Dreams Marketing sangat membantu mengembangkan brand batik kami. Sekarang pelanggan dari luar kota bahkan luar Jawa banyak yang tahu produk kami!",
      author: "Ahmad Fauzi",
      position: "Owner Toko Batik Nusantara"
    },
    
    gallery: [
      "https://images.unsplash.com/photo-1594736797933-d0f06ba28238?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1583394838336-acd977736f90?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1564584217132-2271339e5821?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    ]
  },
  
  3: {
    id: 3,
    title: "Kedai Kopi Kampung",
    category: "Food & Beverage",
    client: "Rina Kusuma", 
    location: "Bandung",
    duration: "4 Bulan",
    overview: "Membangun komunitas online untuk kedai kopi lokal dengan engagement rate tinggi dan customer loyalty yang kuat.",
    challenge: "Kedai kopi dengan konsep unik namun belum memiliki brand identity yang kuat dan community engagement yang rendah.",
    
    beforeAfter: {
      before: {
        image: "https://images.unsplash.com/photo-1559116315-702b0b4774cd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        description: "Kedai kopi sederhana tanpa branding yang kuat"
      },
      after: {
        image: "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        description: "Kedai kopi dengan branding modern dan community yang solid"
      }
    },
    
    strategy: [
      {
        title: "Brand Identity Development",
        description: "Pembuatan logo, interior design guidelines, dan brand personality yang mencerminkan 'kopi kampung modern'."
      },
      {
        title: "Community Building",
        description: "Strategi membangun komunitas pecinta kopi melalui event, workshop, dan customer engagement program."
      },
      {
        title: "Instagram Marketing",
        description: "Konten strategy yang fokus pada storytelling, behind-the-scenes, dan user-generated content."
      },
      {
        title: "Loyalty Program",
        description: "Implementasi program loyalitas pelanggan dengan reward system dan membership benefits."
      }
    ],
    
    results: [
      {
        metric: "Instagram Engagement",
        value: "15%",
        description: "Engagement rate yang tinggi di atas industry average"
      },
      {
        metric: "Repeat Customers",
        value: "80%",
        description: "80% pelanggan menjadi regular customer"
      },
      {
        metric: "Monthly Revenue",
        value: "Rp 25 Juta",
        description: "Peningkatan revenue bulanan sebesar 180%"
      },
      {
        metric: "Community Members",
        value: "500+",
        description: "Anggota komunitas aktif di berbagai platform"
      }
    ],
    
    testimonial: {
      text: "Strategi media sosial dari Dreams Marketing bikin kedai kopi kami viral di Instagram. Customer jadi antri terus dan banyak yang jadi langganan!",
      author: "Rina Kusuma",
      position: "Owner Kedai Kopi Kampung"
    },
    
    gallery: [
      "https://images.unsplash.com/photo-1447933601403-0c6688de566e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    ]
  },
  
  4: {
    id: 4,
    title: "Kerajinan Bambu Lokal",
    category: "Handicraft",
    client: "Budi Santoso",
    location: "Solo", 
    duration: "10 Bulan",
    overview: "Penetrasi pasar ekspor untuk kerajinan bambu tradisional dengan strategi digital marketing yang tepat sasaran.",
    challenge: "Produk kerajinan bambu berkualitas tinggi namun belum memiliki akses ke pasar internasional dan digital presence yang minim.",
    
    beforeAfter: {
      before: {
        image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        description: "Kerajinan bambu tradisional dengan pasar lokal terbatas"
      },
      after: {
        image: "https://images.unsplash.com/photo-1586380951230-c2d4ac1f324c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        description: "Brand kerajinan bambu dengan jangkauan pasar internasional"
      }
    },
    
    strategy: [
      {
        title: "Export Market Research",
        description: "Riset mendalam tentang tren pasar kerajinan bambu di Amerika, Eropa, dan Australia."
      },
      {
        title: "B2B Digital Marketing",
        description: "Strategi marketing B2B melalui LinkedIn, trade platforms, dan international marketplace."
      },
      {
        title: "Product Photography",
        description: "Professional product photography dan video showcasing untuk meningkatkan appeal produk."
      },
      {
        title: "International SEO",
        description: "Optimisasi website untuk search engine internasional dengan multi-language support."
      }
    ],
    
    results: [
      {
        metric: "Export Sales",
        value: "400%",
        description: "Peningkatan penjualan ekspor dalam 10 bulan"
      },
      {
        metric: "International Orders",
        value: "50+",
        description: "Order dari 12 negara berbeda"
      },
      {
        metric: "B2B Partnerships",
        value: "25",
        description: "Kemitraan dengan distributor internasional"
      },
      {
        metric: "Revenue Growth",
        value: "Rp 200 Juta",
        description: "Total revenue dari pasar ekspor"
      }
    ],
    
    testimonial: {
      text: "Dreams Marketing membantu kami menembus pasar internasional. Sekarang produk kerajinan bambu kami diekspor ke 12 negara dan permintaan terus meningkat!",
      author: "Budi Santoso",
      position: "Owner Kerajinan Bambu Lokal"
    },
    
    gallery: [
      "https://images.unsplash.com/photo-1578681994506-b8f463449011?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1586127411222-95c70e55b302?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1565814329452-e1efa11c5b89?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    ]
  }
};